import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setSeo } from "@/lib/api";
import { PLANNING_TOOLS_VISIBLE } from "@/lib/features";

export const Loading = ({ label = "Loading" }) => (
  <div data-testid="page-loading" className="min-h-[55vh] flex items-center justify-center">
    <span className="text-[11.5px] tracking-[0.2em] uppercase text-[#736F68]">{label}…</span>
  </div>
);

export default function NotFound({
  title = "We couldn't find that page",
  body = "The page may have moved, or it may be a guide that is still in research and not published yet.",
}) {
  useEffect(() => {
    setSeo({
      title: `${title} — Human Home Living`,
      description: "Page not found on Human Home Living.",
      noindex: true,
      follow: false,
    });
  }, [title]);

  return (
    <div data-testid="not-found-page" className="px-5 md:px-8 py-24 md:py-32">
      <div className="max-w-[720px] mx-auto">
        <span className="eyebrow">404</span>
        <h1 className="display text-[38px] md:text-[52px] leading-[1.05] mt-5 text-charcoal">{title}</h1>
        <p className="text-[17px] md:text-[19px] font-light leading-[1.6] text-[#5A5A5A] mt-5">{body}</p>
        <div className="flex flex-col sm:flex-row gap-3.5 mt-9">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center justify-center px-8 py-4 bg-charcoal text-white text-[12.5px] tracking-[0.16em] uppercase hover:bg-sage transition-colors duration-300"
          >
            Back to the homepage
          </Link>
          {PLANNING_TOOLS_VISIBLE && (
            <Link
              to="/tools"
              data-testid="not-found-tools-link"
              className="inline-flex items-center justify-center px-8 py-4 border border-charcoal/25 text-charcoal text-[12.5px] tracking-[0.16em] uppercase hover:border-sage hover:text-sage transition-colors duration-300"
            >
              Try our planning tools
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
